"use strict";

import { EventBus } from "../bus";

const BOT_CONFIRM_DIALOG_OPEN = "$botConfirmDialogOpen";
const BOT_CONFIRM_DIALOG_CANCEL = "$botConfirmDialogCancel";
const BOT_CONFIRM_DIALOG_OK = "$botConfirmDialogOk";

// eslint-disable-next-line
export default (Vue, options) => {
  Vue.mixin({
    methods: {
      // eslint-disable-next-line
      botConfirmDialog(options) {
        EventBus.$emit(BOT_CONFIRM_DIALOG_OPEN, options);
        return new Promise((resolve, reject) => {
          EventBus.$once(BOT_CONFIRM_DIALOG_OK, function() {
            resolve();
          });
          EventBus.$once(BOT_CONFIRM_DIALOG_CANCEL, function() {
            reject();
          });
        });
      }
    }
  });
};

export {
  BOT_CONFIRM_DIALOG_OPEN,
  BOT_CONFIRM_DIALOG_CANCEL,
  BOT_CONFIRM_DIALOG_OK
};
